import { initializeApp } from 'firebase/app';
import {
  getMessaging, getToken, onMessage, isSupported
} from 'firebase/messaging';
import { FIREBASE_CONFIG, FIREBASE_VAPID } from '../common/config';

const firebaseApp = initializeApp(FIREBASE_CONFIG);

let messaging;
isSupported().then((res) => {
  if (res) {
    messaging = getMessaging(firebaseApp);
  } else {
    messaging = null;
  }
});

export default firebaseApp;

export const requestForToken = async () => {
  if (!messaging) {
    return '0';
  }
  const permission = await Notification.requestPermission();
  if (permission === 'granted') {
    const currentToken = await getToken(messaging, { vapidKey: FIREBASE_VAPID })
      .catch((err) => console.error('An error occurred while retrieving token. ', err));
    if (currentToken) {
      return currentToken;
      // Perform any other neccessary action with the token
    }
  }
  return '0';
};

export const targetPages = (targetCase) => ({
  NOTIFICATIONS: `${origin}/notifications`,
  CALENDAR: `${origin}/manage-cases`,
  CASE: `${origin}/manage-case/${targetCase || ''}`,
  BACKORDERS: `${origin}/inventory/backorders`,
  SHIPMENTS: `${origin}/inventory/shipments`,
  CONSIGNMENTS: `${origin}/inventory/consignment`,
  REPORTS: `${origin}/reports`,
  MISSING_DGRS: `${origin}/missing-dgr`,
  MISSING_POS: `${origin}/missing-pos`,
  UNBILLED: `${origin}/billing/notBilledCases`
});

export const onMessageListener = () => new Promise((resolve, reject) => {
  let foregroundMessaging;
  isSupported().then((res) => {
    if (res) {
      foregroundMessaging = getMessaging(firebaseApp);
      onMessage(foregroundMessaging, (payload) => {
        // console.log('payload', payload);
        const notificationTitle = payload.data.title;
        const notificationOptions = {
          body: payload.data.body,
        };
        if (!('Notification' in window)) {
          console.warn('This browser does not support system notifications');
        } else if (Notification.permission === 'granted') {
          // eslint-disable-next-line no-unused-vars
          const notification = new Notification(notificationTitle, notificationOptions);
          // console.log('notification', notification);
          notification.onclick = (event) => {
            event.preventDefault();
            notification.close();
            const { targetPage, targetCase } = payload.data;
            const { origin } = window.location;
            const defaultURL = `${origin}/notifications`;
            if (!targetPage) {
              return window.open(defaultURL, '_self');
            }
            switch (targetPage) {
              case 'NOTIFICATIONS':
                window.open(`${origin}/notifications`, '_self');
                break;
              case 'CALENDAR':
                window.open(`${origin}/manage-cases`, '_self');
                break;
              case 'CASE':
                window.open(`${origin}/manage-case/${targetCase || ''}`, '_self');
                break;
              case 'BACKORDERS':
                window.open(`${origin}/inventory/backorders`, '_self');
                break;
              case 'SHIPMENTS':
                window.open(`${origin}/inventory/shipments`, '_self');
                break;
              case 'CONSIGNMENTS':
                window.open(`${origin}/inventory/consignment`, '_self');
                break;
              case 'REPORTS':
                window.open(`${origin}/reports`, '_self');
                break;
              case 'MISSING_DGRS':
                window.open(`${origin}/missing-dgr`, '_self');
                break;
              case 'MISSING_POS':
                window.open(`${origin}/missing-pos`, '_self');
                break;
              case 'UNBILLED':
                window.open(`${origin}/billing/notBilledCases`, '_self');
                break;
              default:
                window.open(defaultURL, '_self');
            }
          };
        }
        resolve(payload);
      });
    } else {
      reject();
    }
  });
});
